// --- STEP 1 & 2: Initialize Autocomplete & Listen for selection ---

let autocomplete;

function initStoreLocator() {
    // 1. Target the input field
    const inputField = document.getElementById('searchStore');

    // 2. Prevent the 'Enter' key from submitting the form and reloading the page
    inputField.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault(); 
        }
    });

    // 2/bis Init filter by stock  
    initFilters();
      
    // 2/ter Init geoloc button
    const geoBtn = document.getElementById('geolocateMe');
    if (geoBtn) {
        geoBtn.addEventListener('click', function() {
            handleGeolocation(geoBtn); // On passe directement la référence du bouton
        });
    }

    // 3. Define Autocomplete options
    const options = {
        componentRestrictions: { country: "fr" }, 
        fields: ["geometry"], // Save costs: request only coordinates
        types: ["geocode"] 
    };

    // 4. Initialize Google Autocomplete
    autocomplete = new google.maps.places.Autocomplete(inputField, options);

    // 5. Listen for the event when the user selects a prediction
    autocomplete.addListener('place_changed', function() {
        const place = autocomplete.getPlace();
        
        // --- UX Error Handling ---
        const errorElement = document.getElementById('searchStore-error');

        // IF ERROR: The user pressed Enter on a random text or API failed
        if (!place.geometry || !place.geometry.location) {
            // Show the error message
            if (errorElement) errorElement.style.display = 'block';
            // Optional: Make the input border red to draw attention
            inputField.style.border = '1px solid #d9534f'; 

            // Clean up the distances on the screen ---
            resetDistances();            
            
            return; // Stop the function here, we can't calculate distances!
        }

        // IF SUCCESS: Hide the error message if it was visible from a previous mistake
        if (errorElement) errorElement.style.display = 'none';
        // Reset the input border to its default state
        inputField.style.border = ''; 

        // Extract Latitude and Longitude
        const userLat = place.geometry.location.lat();
        const userLng = place.geometry.location.lng();

        console.log("🎯 User coordinates:", userLat, userLng);

        // Trigger the calculation and sorting functions
        calculateDistances(userLat, userLng);        
    });
}

// --- STEP 3: Math and Distance Calculation ---

// 1. Helper function to convert degrees to radians
function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

// 2. The Haversine formula to calculate distance on a sphere
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    
    const a = 
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    
    return distance;
}

// 3. Function to loop through stores, calculate distance, and prepare for sorting
function calculateDistances(userLat, userLng) {
    // Target all store elements in the DOM based on your custom tag
    const stores = document.querySelectorAll('store-item');
    
    stores.forEach(store => {
        // Get coordinates from the HTML data attributes you showed in the screenshot
        const storeLat = parseFloat(store.getAttribute('data-lat'));
        const storeLng = parseFloat(store.getAttribute('data-lng'));
        
        // Check if both coordinates exist and are valid numbers
        if (!isNaN(storeLat) && !isNaN(storeLng)) {
            // Calculate the distance using our Haversine function
            const distanceInKm = getDistanceFromLatLonInKm(userLat, userLng, storeLat, storeLng);
            
            // Store the distance in a new data attribute so we can sort the HTML later
            store.setAttribute('data-distance', distanceInKm);
            
            // Log it to the console to verify everything works perfectly
            //console.log(`📍 Distance to store: ${distanceInKm.toFixed(2)} km`);

            // Inject the distance text into the title ---
            // Target the specific title class
            const titleElement = store.querySelector('.product-item-meta__title');
            if (titleElement) {
                // Check if our span already exists to avoid duplicates
                let distanceSpan = titleElement.querySelector('.store-distance-label');
                
                // If it doesn't exist, we create it
                if (!distanceSpan) {
                    distanceSpan = document.createElement('span');
                    distanceSpan.className = 'store-distance-label';
                    
                    // Append it at the end of the title element
                    titleElement.appendChild(distanceSpan);
                }
                
                // Update the text content with the calculated distance
                distanceSpan.textContent = `(${distanceInKm.toFixed(1)} km)`;
            }

        }
    });

    // Then Sort stores
    sortStoresByDistance(); 
    
}

// Function to clean up distances if the user makes an error or clears the input
function resetDistances() {
    const stores = document.querySelectorAll('store-item');
    
    stores.forEach(store => {
        // 1. Remove the sorting attribute
        store.removeAttribute('data-distance');
        
        // 2. Find and remove the distance span if it exists in the DOM
        const distanceSpan = store.querySelector('.store-distance-label');
        if (distanceSpan) {
            distanceSpan.remove();
        }
    });
}

// --- STEP 4: Sort stores visually based on calculated distance ---

function sortStoresByDistance() {
    // 1. Target the parent container that holds all the stores
    const container = document.getElementById('store-availability');
    if (!container) return; // Safety check

    // 2. Get all store items and convert the NodeList into a real Array so we can use .sort()
    const stores = Array.from(container.querySelectorAll('store-item'));

    // 3. Sort the array based on the 'data-distance' attribute
    stores.sort((a, b) => {
        // Extract distances. If a distance is missing (NaN), we set it to Infinity so it drops to the bottom
        const distanceA = parseFloat(a.getAttribute('data-distance')) || Infinity;
        const distanceB = parseFloat(b.getAttribute('data-distance')) || Infinity;
        
        // Ascending order: lowest distance first
        return distanceA - distanceB; 
    });

    // 4. Re-inject the sorted elements back into the container
    // Magic trick: using appendChild on an existing element doesn't duplicate it, it just moves it!
    stores.forEach(store => {
        container.appendChild(store);
    });

    //console.log("✅ Stores successfully sorted by distance!");
}


// --- Stock Filtering Logic ---

function filterStores(isOnlyStockChecked) {
    const stores = document.querySelectorAll('store-item');

    stores.forEach(store => {
        const hasStock = store.getAttribute('data-has-stock') === 'true';

        if (isOnlyStockChecked && !hasStock) {
            store.style.display = 'none';
        } else {
            store.style.display = '';
        }
    });
}

/**
 * We look for the checkbox ONLY ONCE here.
 */
function initFilters() {
    const stockCheckbox = document.getElementById('toggleStock');
    
    if (stockCheckbox) {
        // Initial run: we pass the initial state
        filterStores(stockCheckbox.checked);

        // Listener: we pass the new state on every change
        stockCheckbox.addEventListener('change', function() {
            filterStores(stockCheckbox.checked);
        });
    }
}


// NAV GEOLOC

async function handleGeolocation(btn) {
    if (!navigator.geolocation) {
        alert("La géolocalisation n'est pas supportée par votre navigateur.");
        btn.disabled = true;
        return;
    }

    // 1. Check current user permission status
    try {
        const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
        
        if (permissionStatus.state === 'denied') {
            alert("Vous avez bloqué l'accès à la localisation. Veuillez l'activer dans les réglages de votre navigateur pour utiliser cette fonction.");
            btn.disabled = true;
            return;
        }
    } catch (e) {
        // Cover case when nav does not support query by name geolocation
        // Continue
    }

    // 2. UI updates
    btn.classList.add('is-loading');
    btn.disabled = true; // On évite le double clic

    // 3. Appel natif (le navigateur affichera sa propre pop-up de consentement ici)
    navigator.geolocation.getCurrentPosition(
        (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;

            const searchInp = document.getElementById('searchStore');
            searchInp.value = "Ma position actuelle";
            searchInp.focus();
            
            calculateDistances(userLat, userLng);
            
            btn.classList.remove('is-loading');
            btn.disabled = false;
        },
        (error) => {
            btn.classList.remove('is-loading');
            
            // Gestion des erreurs de consentement
            if (error.code === error.PERMISSION_DENIED) {
                console.warn("L'utilisateur a refusé la demande de géolocalisation.");
                btn.disabled = true; // Disable the button as user manually denied access
            } else {
                btn.disabled = false; // Keep it enabled for retry on technical errors (timeout, etc.)
                alert("Une erreur est survenue lors de la récupération de votre position.");
            }
        },
        { enableHighAccuracy: true, timeout: 7000, maximumAge: 0 }
    );
}